<ng-container *ngIf="formGroup.controls[currentPaymentType] && currentPaymentType === paymentTypes['Wire Transfer']">
  <form [formGroup]="formGroup.controls[currentPaymentType]">
    <div class="mb-14">
      <p500-ui-text-field
        formControlName="Beneficiary name"
        label="Beneficiary Name"
        i18n-label="@@common.beneficiary_name"
      ></p500-ui-text-field>
    </div>
    <div class="mb-14">
      <p500-ui-text-field
        formControlName="Beneficiary address"
        label="Beneficiary Address"
        i18n-label="@@common.beneficiary_address"
      ></p500-ui-text-field>
    </div>
    <div class="mb-14">
      <p500-ui-text-field formControlName="Bank" label="Bank" i18n-label="@@common.bank"></p500-ui-text-field>
    </div>
    <div class="mb-14">
      <p500-ui-text-field formControlName="Bank Address" label="Bank Address" i18n-label="@@common.bank_address"></p500-ui-text-field>
    </div>
    <div class="mb-14">
      <p500-ui-text-field formControlName="Bank Country" label="Bank Country" i18n-label="@@common.bank_country"></p500-ui-text-field>
    </div>
    <div class="mb-14">
      <p500-ui-text-field formControlName="Swift" label="Swift"></p500-ui-text-field>
    </div>
    <div class="mb-14">
      <p500-ui-text-field formControlName="IBAN" label="IBAN"></p500-ui-text-field>
    </div>
    <div class="mb-14">
      <p500-ui-text-field formControlName="REG number" label="REG number" i18n-label="@@common.reg_number"></p500-ui-text-field>
    </div>
    <div class="mb-14">
      <p500-ui-text-field
        formControlName="Owner / Director name"
        label="Owner / Director name"
        i18n-label="@@common.owner_director_name"
      ></p500-ui-text-field>
    </div>
  </form>
</ng-container>
